import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Geoportal from "@/pages/Geoportal";

function App() {
  return (
    <div className="App">
      <Toaster theme="dark" position="bottom-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Geoportal />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
